import type { DocPageContent } from '../docs-content'

const page = {
  order: 8,
  slug: 'preview',
  title: '预览与播放',
  description:
    '播放、逐帧步进、缩放监视器、进入全屏、保存帧，以及使用代理播放。',
  category: '核心编辑',
  related: ['timeline', 'effects-color'],
  sections: [
    {
      title: '播放与导航',
      blocks: [
        {
          kind: 'list',
          items: [
            '使用预览控件或 `Space` 进行播放与暂停。',
            '使用 `Left` 和 `Right` 逐帧步进，以便进行逐帧精确的核对。',
            '用 `Home` 跳到时间轴开头，用 `End` 跳到结尾。',
            '读取时码显示以确认播放头的精确位置。',
          ],
        },
      ],
    },
    {
      title: '取景与视图',
      blocks: [
        {
          kind: 'list',
          items: [
            '调整预览缩放以查看细节；这不会改变导出画布。',
            '在检视运动或构图时使用**全屏**，用退出全屏返回。',
            '使用**保存帧**将当前帧写入图像文件。',
            '当选中匹配项时，变换、遮罩与编辑叠加层会显示在监视器上。',
          ],
        },
      ],
    },
    {
      title: '播放性能与音频',
      blocks: [
        {
          kind: 'list',
          items: [
            '当存在代理文件时，精剪会使用它们来更流畅地播放重型媒体；导出仍使用原始文件。',
            '监视器音量控件仅影响本地播放。',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '导出使用项目混音，因此监视器音量永远不会更改渲染出的音频。',
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
